import Utils from "../utils";
import RenderManager from "./render-manager";
import SlideManager from "../utils/slide-manager";

class Q3Fog {
    constructor() {
        this._tween = null;
        this._active = false;
        this._activeFog = null;

        if (Q3.editMode || SlideManager.slides.find(x => x.fog.type === 2)) {
            const density = this.getFogDensityForSlide(0);
            const color = this.getFogColorForSlide(0);

            this._activeFog = new THREE.FogExp2(color, density);
            RenderManager.root.fog = this._activeFog;
            if (RenderManager.activeScene) {
                RenderManager.activeScene.fog = this._activeFog;
            }

            this._active = true;
        }
    }

    get activeFog() { return this._activeFog; }

    setSlideFog(slide, duration = 1.5) {
        if (!this._active) return;

        if (this._tween) {
            this._tween.kill();
            this._tween = null;
        }

        const fog = this._activeFog;
        const from = { density: fog.density };
        const to = { density: this.getFogDensityForSlide(slide) };

        if (from.density > 0 && to.density > 0) {
            from.color = fog.color.clone();
            to.color = this.getFogColorForSlide(slide);
        } else if (to.density > 0) {
            fog.color = this.getFogColorForSlide(slide);
        }

        this._tween = TweenMax.fromTo(fog, duration, from, to);
        this._tween.eventCallback("onUpdate", function () {
            RenderManager.activeCamera.update = true;
        });
    }


    getFogDensityForSlide(slide) {
        const slideData = SlideManager.getSlide(slide);

        return slideData.fog.type === 2 ? slideData.fog.density : 0;
    }

    getFogColorForSlide(slide) {
        const slideData = SlideManager.getSlide(slide);

        switch (slideData.background.type) {
            case "image":
            case "texture":
            case "panorama":
                const isMobile = Q3.editMode ? Q3.mobileView : Q3.browserCapabilities.isMobile;
                const bgValue = isMobile && slideData.background.value.image.texture
                    || slideData.background.value.image.textureMobile;
                const texture = Q3.data.assets.textures[bgValue];
                const dominantColor = texture ? texture.dominantColor : null;

                return dominantColor
                    ? new THREE.Color(Utils.rgbToHex(dominantColor))
                    : new THREE.Color("#777777");
            case "color":
                if (slideData.background.value.color.primary)
                    return new THREE.Color(slideData.background.value.color.primary);
        }

        return new THREE.Color("#FFFFFF");
    }
}

export default Q3Fog;
export { Q3Fog };